module.exports = __webpack_public_path__ + "img/icons_voluntary_coach-w_border.467ad2bf.svg";